export const secureURL =
  process.env.GATSBY_ENV === 'production'
    ? 'https://secure.everlywell.com'
    : process.env.GATSBY_ENV === 'staging'
    ? 'https://secure-staging.everlywell.com'
    : 'https://secure-qa.everlywell.com';

export const resultsURL =
  process.env.GATSBY_ENV === 'production'
    ? 'https://results.everlywell.com'
    : process.env.GATSBY_ENV === 'staging'
    ? 'https://results-staging.everlywell.com'
    : 'https://results-qa.everlywell.com';

export const wwwURL =
  process.env.GATSBY_ENV === 'production'
    ? 'https://www.everlywell.com'
    : process.env.GATSBY_ENV === 'staging'
    ? 'https://staging.everlywell.com'
    : 'https://qa.everlywell.com';
